import { ApiServiceBase } from '../api-service-base';
import { ExperimentAnalytics } from '../types';

interface GetExperimentAnalyticsArguments {
  shopId: number;
  experimentId: string;
  deviceType?: string;
}

export class AbTestAnalyticsApiService extends ApiServiceBase {
  constructor() {
    super('shops');
  }

  private getAnalyticsPath(shopId: number, experimentId: string): string {
    return `${this.serviceBaseUri}/${shopId}/experiments/${experimentId}/analytics`;
  }

  async getExperimentAnalytics({
    shopId,
    experimentId,
    deviceType,
  }: GetExperimentAnalyticsArguments): Promise<ExperimentAnalytics> {
    const url = this.getAnalyticsPath(shopId, experimentId);
    const params = deviceType ? { deviceType } : undefined;
    const response = await this.httpService.get({ url, requestConfig: { params } });
    const data = response.data ?? {};
    const variants = (data.variants ?? []).map((v: any) => ({
      ...v,
      lift: v.lift ?? { cvr: 0, aov: 0, arpu: 0 },
    }));
    const testVariants = variants.filter((v: any) => v.variantType !== 'control');
    const deltas = {
      cvr: testVariants.length ? Math.max(...testVariants.map((v: any) => v.lift.cvr)) : 0,
      aov: testVariants.length ? Math.max(...testVariants.map((v: any) => v.lift.aov)) : 0,
      arpu: testVariants.length ? Math.max(...testVariants.map((v: any) => v.lift.arpu)) : 0,
    };
    return { ...data, variants, deltas };
  }
}

export const abTestAnalyticsApiService = new AbTestAnalyticsApiService();
